import React from 'react';
import { Grid, Box } from '@mui/material';
import { CommentListItem } from './CommentListItem';
import { BackdropLoading } from '../BackdropLoading';

interface CommentListProps {
  comments: any[];
  commentsLoading: boolean;
}

export const CommentList = ({
  comments,
  commentsLoading,
}: CommentListProps) => {
  return (
    <Box sx={{ px: { xs: 2, sm: 3 }, py: 4 }}>
      {commentsLoading ? (
        <BackdropLoading />
      ) : (
        <Grid container spacing={2}>
          {comments?.map((comment, index) => (
            <Grid key={`comment-item-${index}`} item xs={12}>
              <CommentListItem comment={comment} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};
